/* eslint-disable react/prop-types */
import PropTypes from "prop-types";
import { memo } from "react";
import { components } from "react-select";

const DestinationInputValueFormat = props => {
	const { data } = props;

	return (
		<components.SingleValue
			{...props}
			{...props.selectProps.inputValueIcon && {
				className: "advanced-select__select__single-value-icon",
			}}
		>
			<div className="search-form__suggestion-label">{data.label}</div>
			{props.selectProps.inputValueIcon && props.selectProps.inputValueIcon}
		</components.SingleValue>
	);
};

DestinationInputValueFormat.propTypes = {
	data: PropTypes.object,
	getStyles: PropTypes.func,
};

export default memo(DestinationInputValueFormat);
